import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  findAllBrandsPageble,
  createBrand,
  deleteBrand,
  updateBrand,
  deleteErrorBrand,
} from '../../actions/brand';
import BrandTable from '../Brand/BrandTable';
import { HeaderTable } from '../../enums/BrandEnums';
import { TableContainer } from '../Reusable/TableContainer';
import ModalForAddBrand from '../Brand/ModalForAddBrand';

const BrandList = () => {
  const dispatch = useDispatch();
  const brandReducer = useSelector((state) => state.brand);

  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorBrand());
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleAdd = (brand) => {
    dispatch(createBrand(brand, handlePreviewClose));
  };

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForBrandTable}
        showModal={showModal}
      >
        <BrandTable
          dispatch={dispatch}
          brandReducer={brandReducer}
          findAllBrandsPageble={findAllBrandsPageble}
          updateBrand={updateBrand}
          deleteBrand={deleteBrand}
          clearValidationErrors={clearValidationErrors}
        />
      </TableContainer>
      {show && (
        <ModalForAddBrand
          brandReducer={brandReducer}
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
        />
      )}
    </>
  );
};

export default BrandList;
